import React from 'react';

import AppStoreCallout from '@rover/react-lib/src/pages/shared/AppStoreCallout/AppStoreCallout';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

import ServiceLandingFooterLinks from './components/ServiceLandingFooterLinks';
import ServiceLandingPageWrapper from './components/ServiceLandingPageWrapper';
import ServiceLandingRoverProtect from './components/ServiceLandingRoverProtect';
import ServiceLandingSection, {
  SERVICE_LANDING_SECTION_MARGIN_Y,
} from './components/ServiceLandingSection';
import type { ServiceLandingTemplateProps } from './types';

const ServiceLandingPageTemplate: React.FC<ServiceLandingTemplateProps> = ({
  serviceLandingData,
  countryConfig,
  citiesAndNeighborhoodsLinks,
  countryFooterLinks,
  countryRegionLinks,
}) => {
  const { h1, h2, seoTitle, seoMetaDescription, internalServiceType } = serviceLandingData;
  const { displayName: serviceTypeName } = internalServiceType;
  const brandName = getBrandDisplayName();

  return (
    <ServiceLandingPageWrapper
      seoTitle={seoTitle}
      seoMetaDescription={seoMetaDescription}
      serviceTypeName={serviceTypeName}
      brandName={brandName}
      h1={h1}
      h2={h2}
      countryConfig={countryConfig}
    >
      <ServiceLandingRoverProtect my={SERVICE_LANDING_SECTION_MARGIN_Y} />

      <ServiceLandingSection mb={['0x', '0x']} data-qa-id="service-landing-download-app-callout">
        <AppStoreCallout />
      </ServiceLandingSection>

      <ServiceLandingFooterLinks
        citiesAndNeighborhoodsLinks={citiesAndNeighborhoodsLinks}
        countryFooterLinks={countryFooterLinks}
        countryRegionLinks={countryRegionLinks}
      />
    </ServiceLandingPageWrapper>
  );
};

export default ServiceLandingPageTemplate;
